import { render, staticRenderFns } from "./Lateness.vue?vue&type=template&id=050df313&scoped=true"
import script from "./Lateness.vue?vue&type=script&lang=js"
export * from "./Lateness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050df313",
  null
  
)

export default component.exports